const HYDRATION_ATTRIBUTE = 'data-hydration-id';

export { HYDRATION_ATTRIBUTE };
